export type ReaderLandingCtaState = 'open-scene' | 'download-app'

export type ReaderLandingCta = {
  label: string
  href: string
  state: ReaderLandingCtaState
}

const SCENE_APP_DEEP_LINK = '#scene-app-link'
const SCENE_APPSTORE_LINK = '#scene-appstore-link'
const SCENE_PLAYSTORE_LINK = '#scene-playstore-link'

export const DEFAULT_READER_LANDING_CTA: ReaderLandingCta = {
  label: 'Scene 바로 보기',
  href: SCENE_PLAYSTORE_LINK,
  state: 'download-app',
}

function getSceneDownloadLink() {
  if (typeof navigator === 'undefined') {
    return SCENE_PLAYSTORE_LINK
  }

  const userAgent = navigator.userAgent.toLowerCase()

  return /iphone|ipad|ipod|mac|macintosh/.test(userAgent)
    ? SCENE_APPSTORE_LINK
    : SCENE_PLAYSTORE_LINK
}

function getForcedSceneCtaState(): ReaderLandingCtaState | null {
  if (typeof window === 'undefined') {
    return null
  }

  const forcedState = new URLSearchParams(window.location.search).get('sceneCta')

  if (forcedState === 'open-scene' || forcedState === 'download-app') {
    return forcedState
  }

  return null
}

function detectSceneInstalled() {
  const forcedState = getForcedSceneCtaState()

  if (forcedState) {
    return forcedState === 'open-scene'
  }

  // TODO: Replace this placeholder with the real Scene app install detection
  // or universal link strategy once the mobile app opening flow is finalized.
  const hasSceneInstalled = false

  return hasSceneInstalled
}

export function getReaderLandingCta(): ReaderLandingCta {
  if (detectSceneInstalled()) {
    return {
      label: 'Scene 바로 보기',
      href: SCENE_APP_DEEP_LINK,
      state: 'open-scene',
    }
  }

  return {
    label: 'Scene 바로 보기',
    href: getSceneDownloadLink(),
    state: 'download-app',
  }
}

export function isReaderLandingPlaceholderHref(href: string) {
  return href.startsWith('#scene-')
}
